<template>
<div id="reset-password">
  <div class="container">
    <div class="jumbotron">
      <div class="row">
        <div class="col-md-offset-3 col-md-6 text-center">
          <h1>SPIADI</h1>
          <p>
            Surveillance et Prévention des Infections Associées
            aux Dispositifs Invasifs
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-offset-1 col-xs-10 col-sm-offset-2
                  col-sm-8 col-md-offset-4 col-md-4">
        <div class="panel panel-default">
          <div class="panel-body">
            <h4><strong>Changement de mot de passe</strong></h4>
            <p>
              Veuillez saisir votre email et votre nouveau mot de passe.
            </p>
            <div class="form-group"
                 :class="{ 'has-error': emailError }">
              <label for="name" class="control-label">Adresse e-mail</label>
              <input required
                     id="rp_email"
                     tabindex="1"
                     autofocus
                     class="form-control"
                     v-model.trim="rp_email"
                     :disabled="waiting"
                     type="email"
                     placeholder="Adresse email"/>
            </div>
            <ul class="mail-test">
              <li>
                <span :class="mail.iconClass" aria-hidden="true"></span>
                <span v-html="mail.label"
                  :class="mail.labelClass">
                </span>
              </li>
            </ul>
            <div class="form-group"
                 :class="{ 'has-error': passwordError }">
              <label for="name" class="control-label">
                Nouveau mot de passe
              </label>
              <div class="input-group">
                <input required
                        id="rp_password"
                        tabindex="1"
                        class="form-control"
                        :disabled="waiting"
                        v-model="rp_password"
                        :type="[showPassword ? 'text' : 'password']"
                        placeholder="Nouveau mot de passe"/>
                <span :class="[showPassword ? 'toggle-pass glyphicon glyphicon-eye-close' : 'toggle-pass glyphicon glyphicon-eye-open']"
                      @click="showPassword = !showPassword">
                </span>
              </div>
            </div>
            <ul class="pass-complexity">
              <li v-for="(r, k) in complexity"
                :key="`${k}-complexity`">
                <span :class="r.iconClass" aria-hidden="true"></span>
                <span v-html="r.label"
                  :class="r.labelClass">
                </span>
              </li>
            </ul>
            <div class="form-group"
                 :class="{ 'has-error': confirmedPasswordError }">
              <label for="name" class="control-label">
                Confirmation du mot de passe
              </label>
              <div class="input-group">
                <input required
                      id="rp_confirmed_password"
                      tabindex="1"
                      class="form-control"
                      :disabled="waiting"
                      v-model="rp_confirmed_password"
                      :type="[showConfirmedPassword ? 'text' : 'password']"
                      placeholder="Confirmer le mot de passe"/>
                <span :class="[showConfirmedPassword ? 'toggle-pass glyphicon glyphicon-eye-close' : 'toggle-pass glyphicon glyphicon-eye-open']"
                      @click="showConfirmedPassword = !showConfirmedPassword">
                </span>
              </div>
            </div>
            <ul class="pass-match">
              <li>
                <span :class="match.iconClass" aria-hidden="true"></span>
                <span v-html="match.label"
                  :class="match.labelClass">
                </span>
              </li>
            </ul>
            <collapse v-model="showError">
              <alert type="danger">
                <strong>{{ errorTitle }}</strong>
                <p>{{ error }}</p>
              </alert>
            </collapse>
            <btn id="change-button"
                 type="success"
                 tabindex="1"
                 :disabled="!this.checkFormContent()"
                 block
                 @click="resetPassword">Enregistrer</btn>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import tools from '@/sui/tools/main'

export default {
  name: 'resetPassword',

  data () {
    return {
      rp_email: '',
      rp_password: '',
      rp_confirmed_password: '',
      website: '',
      emailError: false,
      passwordError: false,
      confirmedPasswordError: false,
      errorTitle: '',
      error: '',
      waiting: false,
      showPassword: false,
      showConfirmedPassword: false
    }
  },

  created () {
    if (this.$store.getters['user/isSessionExpired']) {
      this.errorTitle = 'Session expirée.'
      this.error = 'Merci de vous reconnecter.'
    }
  },

  computed: {
    showError: function () {
      return this.error !== '' || this.errorTitle !== ''
    },
    mail: function () {
      const r = tools.isEmailValid(this.rp_email)

      const resultMa = {
        label: 'Email valide',
        mailTest: r,
        iconClass: this.setIconClasses(r),
        labelClass: this.setLabelClass(r)
      }
      return resultMa
    },
    complexity: function () {
      const lengthTest = this.rp_password.length >= 8
      const regexTest = (r, s) => {
        return r.test(s)
      }

      const upper = new RegExp(/[A-Z\u00C0-\u00D6\u00D8-\u00DD\u00DF]+/)
      const lower = new RegExp(/[a-z\u00E0-\u00F6\u00F8-\u00FD\u00FF]+/)
      const number = new RegExp(/[0-9]+/)
      const spec = new RegExp(/[\u0021-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E\u00A3\u00A4\u00A7\u00A8\u00B2\u00B5]+/)

      const resultR = [
        { label: `8 caractères minimum`, regTest: lengthTest },
        { label: `1 caractère majuscule`, regex: upper },
        { label: `1 caractère minuscule`, regex: lower },
        { label: `1 chiffre`, regex: number },
        { label: `1 caractère spécial`, regex: spec }
      ]

      resultR.forEach(r => {
        if (r.regTest == null) {
          r.regTest = regexTest(r.regex, this.rp_password)
        }
        r.iconClass = this.setIconClasses(r.regTest)
        r.labelClass = this.setLabelClass(r.regTest)
      })
      return resultR
    },

    match: function () {
      const r =
        this.rp_password === this.rp_confirmed_password &
        this.rp_password !== ''

      const resultM = {
        label: 'Mots de passe identiques',
        matchTest: r,
        iconClass: this.setIconClasses(r),
        labelClass: this.setLabelClass(r)
      }
      return resultM
    }
  },

  methods: {
    resetPassword: function () {
      this.errorTitle = ''
      this.error = ''
      if (!this.website === '') {
        return
      }

      this.waiting = true
      this.emailError = this.passwordError = this.confirmedPasswordError = false
      const request = {
        id: this.$route.params.id,
        email: this.rp_email,
        password: this.rp_password,
        prefix: 'users'
      }
      let vm = this
      this.$store.dispatch('password/reset', request).then(
        (response) => {
          vm.waiting = false
          if (response.data.err != null) {
            vm.emailError = true
            vm.passwordError = true
            vm.confirmedPasswordError = true
            vm.errorTitle = 'Echec lors du changement de mot de passe'
            vm.error =
              `La demande de changement de mot de passe n'est pas valide.
Vérifiez que l'adresse e-mail est la même que celle pour laquelle vous avez
demandé le changement. Il est également possible que la demande ait expiré,
dans ce cas il vous suffit de refaire une demande de mot de passe.
            Si le problème persiste veuillez contacter l'administrateur du site.`
          } else {
            vm.$notify({
              type: 'success',
              title: 'Mot de passe changé !',
              content: `Votre mot de passe a bien été changé, vous pouvez
immédiatement vous connecter avec.`
            })

            vm.$router.push('/')
          }
        }
      ).catch(function (e) {
        vm.waiting = false
        if (e.status === 500) {
          vm.errorTitle = 'Erreur interne.'
          vm.error = `Si cette erreur persiste, merci de contacter
un administrateur.`
        } else {
          vm.errorTitle = 'Serveur injoignable.'
          vm.error = `Merci de vérifier votre connexion internet.`
        }
      })
    },

    setIconClasses: function (b) {
      const icon = b ? 'ok' : 'remove'
      const color = b ? 'success' : 'danger'
      return `glyphicon glyphicon-${icon} text-${color}`
    },

    setLabelClass: function (b) {
      return b ? 'crossed' : null
    },

    checkFormContent: function () {
      if (!this.mail.mailTest) {
        return false
      }
      for (let i = 0; i < this.complexity.length; i++) {
        if (!this.complexity[i].regTest) {
          return false
        }
      }
      return this.match.matchTest
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#reset-password {
    min-height: 100%;
    background-color: @base;

    .jumbotron {
        margin-bottom: 0rem;
    }

    #login-button {
        margin-bottom: 1rem;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
  }

  .mail-test,
  .pass-complexity,
  .pass-match {
    padding-left: 1.2rem;
    list-style-type: none;
    margin-bottom: 2rem;
    .glyphicon {
      margin-right: 0.6rem;
    }
  }

  .input-group {
    display: flex;
    .toggle-pass {
      align-self: center;
      margin-left: 0.8rem;
      font-size: 16px;
    }
  }

  .form-group {
    margin-bottom: 0.8rem;
  }

  .crossed {
    text-decoration: line-through;
  }
</style>
